import styled from 'styled-components'

export interface SiteLogoSCProps {}

export const SiteLogoSC = styled.img<SiteLogoSCProps>`
  width: 205px;
  height: auto;
  max-height: 36px;
  object-fit: contain;
  object-position: left center;
`
